<template>
    <div class="lv_flex">
        <div class="menu">
            <el-menu :router="true">
                <el-submenu v-for="group in sceneGroups" :key="group.sceneType" :index="group.sceneType">
                    <template slot="title"><span>{{ group.name }}</span></template>
                    <el-submenu v-for="category in group.categories" :key="category.id" :index="group.sceneType + '-' + category.id">
                        <template slot="title"><span>{{ category.name }}</span></template>
                        <el-menu-item :index="resourcePath(category, group.sceneType, 'list')">列表</el-menu-item>
                        <el-menu-item :index="resourcePath(category, group.sceneType, 'detail')">添加/编辑</el-menu-item>
                    </el-submenu>
                </el-submenu>
                <el-submenu index="user">
                    <template slot="title">
                        <span>用户管理</span>
                    </template>
                    <el-menu-item index="/user/free">免费体验用户</el-menu-item>
                    <el-menu-item index="/user/vip">正式客户列表</el-menu-item>
                    <el-menu-item index="/user/all">全部用户</el-menu-item>
                </el-submenu>
                <el-menu-item index="/label">
                    <span slot="title">标签管理</span>
                </el-menu-item>
                <el-menu-item index="/templateFlower">
                    <span slot="title">首页显示模板管理</span>
                </el-menu-item>
                <el-menu-item index="/AIManage">
                    <span slot="title">AI管理</span>
                </el-menu-item>
                <el-submenu index="version">
                    <template slot="title">
                        <span>版本管理</span>
                    </template>
                    <el-menu-item index="/version/list">列表</el-menu-item>
                </el-submenu>
                <el-submenu index="courseware">
                    <template slot="title">
                        <span>课件管理</span>
                    </template>
                    <el-menu-item index="/courseware/list">列表</el-menu-item>
                </el-submenu>
            </el-menu>
            <div @click="logout">登出</div>
        </div>
        <div class="lv_flex_1 main">
            <router-view />
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return { sceneGroups: [
            { name: "传统插花", sceneType: "TRADITIONAL_FLOWER", categories: [] },
            { name: "园林景观", sceneType: "LANDSCAPE", categories: [] },
            { name: "花艺环境", sceneType: "FLORAL_ENVIRONMENT", categories: [] },
        ] };
    },
    created () { this.loadSceneCategories(); },
    methods: {
        loadSceneCategories () {
            this.sceneGroups.forEach(group => {
                this.$ajax.get("/admin/classifyManage/queryByParentId", { params: { parentId: 0, sceneType: group.sceneType } })
                    .then(res => { group.categories = res.data || []; });
            });
        },
        resourcePath (category, sceneType, action) {
            const id = category.id;
            let path = (id == 1 || category.name === "花材") ? "/flower/" : (id == 2 || category.name === "器皿" || id == 3 || category.name === "剑山") ? "/common/" : "/mockup/";
            if (id == 1 || category.name === "花材") path = action === "detail" ? "/flower/" : "/flower/";
            if (id == 2 || category.name === "器皿") path = action === "detail" ? "/container/" : "/common/";
            if (id == 3 || category.name === "剑山") path = action === "detail" ? "/jianshan/" : "/common/";
            path += action === "list" ? "list" : "detail";
            if (id == 1 || category.name === "花材") path = action === "list" ? "/flower/list" : "/flower/editor";
            return path + "?type=" + encodeURIComponent(id) + "&sceneType=" + encodeURIComponent(sceneType);
        },
        logout () {
            this.$ajax.post("/login/logout").then(() => {
                this.$router.push("/login");
            });
        },
    },
};
</script>
<style>
.lv_flex {
    display: flex;
}

.lv_flex_1 {
    flex: 1;
}

.lv_flexalign_center {
    display: flex;
    align-items: center;
}
</style>
<style lang="scss" scoped>
.main {
    padding: 15px;
    background: #fff;
}

.menu {
    width: 200px;
    height: 100vh;
    background: #fff;
    margin-right: 10px;
}
</style>
